import { createDeliveryClient } from "@kontent-ai/delivery-sdk";
import { ENVIRONMENT_ID } from "../config";

const client = createDeliveryClient({
  environmentId: ENVIRONMENT_ID,
});

const ContentItemsByType = async (contentTypeName: string) => {
  const response = await client
    .items<any>()
    .type(contentTypeName)
    .orderByAscending("system.codename")
    .toPromise();
  return response.data.items;
};

export default ContentItemsByType;
